<template>
  <base-button type="submit" class="btn-primary" text="検索" />
</template>

<script>
import BaseButton from '@/views/atoms/BaseButton';

export default {
  name: 'SearchButton',
  components: {
    BaseButton,
  },
}
</script>
